import styled from "styled-components";

import desImg from "../assets/B-design.jpg";
import teachImg from "../assets/b-teach.jpg";
import codeImg from "../assets/b-coder.jpg";
import classroomImg from "../assets/teacher-classroom.jpg";
import womanCodingImg from "../assets/woman-coding.jpg";

import { mobile } from "../utilities/responsive";

const Container = styled.div`
  margin-left: 60px;

  ${mobile({
    marginLeft: "clamp(30px, calc(5vw + 10px), calc(5vw + 10px))",
  })}
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ebe6dc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: clamp(5rem, 13vw + 1vh, 20rem);
  text-transform: uppercase;
  overflow-x: clip;

  ${mobile({
    height: "100%",
    overflowX: "hidden",
    paddingBottom: "8vh",
  })}
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  z-index: 1;

  ${mobile({ flexDirection: "column" })}
`;

const Img = styled.img`
  border-radius: 0.5rem;
  object-fit: cover;
  width: 100%;
  height: 118%;
  margin: 0;
  animation: zoomImage 2s ease-out forwards;

  @keyframes zoomImage {
    0% {
      transform: scale(1.4);
    }
    100% {
      transform: scale(1);
    }
  }

  ${mobile({
    height: "15vh",
    width: "90vw",
    margin: "0 0",
  })}
`;

const ImgWrap = styled.div`
  overflow: hidden;
  border-radius: 1rem;
  height: min(15rem, calc(25.2vw - 7.7rem));
  width: min(20rem, calc(33.6vw - 10.25rem));
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 2rem;
  z-index: 1;

  &[data-pos="center"] {
    width: 0;
    animation: openCenterImage 0.9s ease forwards;
    animation-delay: 1s;

    @keyframes openCenterImage {
      100% {
        width: min(20rem, calc(33.6vw - 10.25rem));
      }
    }

    ${mobile({
      animation: "none",
      width: "100%",
    })}
  }

  /* &.image::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;
    z-index: 99;
    background: #ebe6dc;
    transform-origin: left;
    animation: hideHorizontal 1s ease forwards;
    animation-delay: 0.3s;
  }
  
  &.image::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 50%;
    z-index: 99;
    background: #ebe6dc;
    transform-origin: right;
    animation: hideHorizontal 1s ease forwards;
    animation-delay: 0.3s;

    @keyframes hideHorizontal {
      0% {
        transform: scaleX(1);
      }
      100% {
        transform: scaleX(0);
      }
    }
  } */

  ${mobile({ margin: "0.75rem 0", height: "15vh", width: "100%" })}

  &[data-pos="end"] {
    ${mobile({ display: "none" })}
  }
`;

const Span = styled.span`
  color: #b5a789;
  font-family: "Big Shoulders Inline Display", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.5rem;
  position: relative;

  :nth-child(odd)::after {
    animation-delay: 0.7s;
  }
  &:nth-child(5)::after {
    animation-delay: 0.6s;
  }
  &:nth-child(7)::after {
    animation-delay: 1s;
  }
  &:nth-child(9)::after {
    animation-delay: 0.3s;
  }
  &:nth-child(3)::after {
    animation-delay: 0.4s;
  }
  &:nth-child(6)::after {
    animation-delay: 0.1s;
  }
  &:nth-child(10)::after {
    animation-delay: 0.5s;
  }
  &:nth-child(1)::after {
    animation-delay: 1.1s;
  }
  &:nth-child(2)::after {
    animation-delay: 1.2s;
  }
  &:nth-child(4)::after {
    animation-delay: 1.3s;
  }
  &:nth-child(8)::after {
    animation-delay: 1.4s;
  }
  &:nth-child(11)::after {
    animation-delay: 0.7s;
  }
  &:nth-child(12)::after {
    animation-delay: 0.8s;
  }
  &:nth-child(13)::after {
    animation-delay: 1.5s;
  }
  &:nth-child(14)::after {
    animation-delay: 0.9s;
  }
  &:nth-child(15)::after {
    animation-delay: 1.1s;
  }
  &:nth-child(16)::after {
    animation-delay: 1.4;
  }
  &:nth-child(17)::after {
    animation-delay: 1.2s;
  }
  &:nth-child(18)::after {
    animation-delay: 1s;
  }

  &:after {
    content: " ";
    width: 100%;
    height: 100%;
    background: #ebe6dc;
    position: absolute;
    bottom: 0;
    left: 0;
    transform-origin: bottom;
    animation: revealCharacter 2.4s forwards;
    animation-timing-function: cubic-bezier(0.12, 0.76, 0.09, 0.96);
  }

  @keyframes revealCharacter {
    0% {
      transform: scaleY(1);
    }

    100% {
      transform: scaleY(0);
    }
  }

  ${mobile({
    fontSize: "calc(6vw + 4vh + 3vmin)",
    letterSpacing: "0.2rem",
  })}
`;

const Text = styled.div`
  display: flex;
  align-items: center;

  ${mobile({
    flexDirection: "column",
  })}
`;

const LineBreak = styled.hr`
  width: 60%;
  margin: 0 10%;
  box-sizing: border-box;
  color: rgba(196, 187, 166, 0.3);

  ${mobile({ display: "none" })}
`;

const SpanWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobile({ display: "flex", flexDirection: "row" })}
`;

const TextBrand = () => {
  return (
    <Container>
      <Wrapper>
        <Row>
          <Text>
            {/* ASH COCA */}
            <ImgWrap>
              <Img src={teachImg} alt="Man teaching at a whiteboard" />
            </ImgWrap>
            <SpanWrapper>
              <Span>E</Span>
              <Span>N</Span>
              <Span>G</Span>
              <Span>I</Span>
              <Span>N</Span>
              <Span>E</Span>
              <Span>E</Span>
              <Span>R</Span>
            </SpanWrapper>
            <ImgWrap>
              <Img src={codeImg} alt="Writing code on a laptop" />
            </ImgWrap>
          </Text>
        </Row>
        <LineBreak />
        <Row>
          <Text>
            {/* TEACH */}
            <SpanWrapper>
              <Span>D</Span>
              <Span>E</Span>
              <Span>S</Span>
              <Span>I</Span>
              <Span>G</Span>
              <Span>N</Span>
            </SpanWrapper>
          </Text>
          <ImgWrap data-pos="center">
            <Img src={desImg} alt="Design workspace with sketches and color swatches" />
          </ImgWrap>
          <Text>
            {/* DESIGNER */}
            <SpanWrapper>
              <Span>T</Span>
              <Span>E</Span>
              <Span>A</Span>
              <Span>C</Span>
              <Span>H</Span>
            </SpanWrapper>
          </Text>
        </Row>
        <LineBreak />
        <Row>
          <Text>
            {/* ENGINEER */}
            <ImgWrap>
              <Img src={classroomImg} alt="Teacher interacting with students in a classroom" />
            </ImgWrap>
            <SpanWrapper>
              <Span>A</Span>
              <Span>S</Span>
              <Span>H</Span>
              <Span>&nbsp;</Span>
              <Span>C</Span>
              <Span>O</Span>
              <Span>C</Span>
              <Span>A</Span>
            </SpanWrapper>
          </Text>
          <ImgWrap data-pos="end">
            <Img src={womanCodingImg} alt="Woman typing code on a laptop" />
          </ImgWrap>
        </Row>
      </Wrapper>
    </Container>
  );
};

export default TextBrand;
